import { create } from 'zustand';

export type DirectFileTransferMetadata = {
  fileName: string;
  size: number;
  mimeType: string;
};

export type IncomingDirectFileTransferRequest = {
  sessionId: string;
  fromIdentityId: string;
  fromIdentityName?: string;
  metadata: DirectFileTransferMetadata;
};

export type ActiveDirectFileTransferSession = {
  sessionId: string;
  direction: 'outgoing' | 'incoming';
  peerIdentityId: string;
  peerDisplayName: string;
  localIdentityId?: string;
  metadata: DirectFileTransferMetadata;
  status: 'preparing' | 'awaiting_accept' | 'connecting' | 'transferring' | 'completed' | 'rejected' | 'failed' | 'cancelled';
  progress: number;
  receivedBlob?: Blob;
  error?: string | null;
  canRetry?: boolean;
  offlineHint?: boolean;
};

export type WaitingDirectFileTransferRequest = {
  localIdentityId: string;
  peerIdentityId: string;
  peerDisplayName: string;
  serverUrl: string;
  startedAt: number;
};

type DirectFileTransferState = {
  incomingRequest: IncomingDirectFileTransferRequest | null;
  waitingRequest: WaitingDirectFileTransferRequest | null;
  activeSession: ActiveDirectFileTransferSession | null;
  setIncomingRequest: (request: IncomingDirectFileTransferRequest | null) => void;
  setWaitingRequest: (request: WaitingDirectFileTransferRequest | null) => void;
  setActiveSession: (session: ActiveDirectFileTransferSession | null) => void;
  patchActiveSession: (patch: Partial<ActiveDirectFileTransferSession>) => void;
  clearActiveSession: () => void;
};

export const useDirectFileTransferStore = create<DirectFileTransferState>((set) => ({
  incomingRequest: null,
  waitingRequest: null,
  activeSession: null,
  setIncomingRequest: (incomingRequest) => set({ incomingRequest }),
  setWaitingRequest: (waitingRequest) => set({ waitingRequest }),
  setActiveSession: (activeSession) => set({ activeSession }),
  patchActiveSession: (patch) => set((state) => ({
    activeSession: state.activeSession ? { ...state.activeSession, ...patch } : null
  })),
  clearActiveSession: () => set({ activeSession: null })
}));
